// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TableSelect_wrapper__zXo9p","flexItem":"TableSelect_flexItem__eZxTn"};